module.exports = __webpack_public_path__ + "static/scale-model-of-buehler-planetarium-in-davie-florida-3bbc9e4dcbc6f31376d9e57b14dd3412.png";